/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} _Field__Enum_Studyprograms_Study_Cultural_Anthropology26Inputs */

const en__field__enum_studyprograms_study_cultural_anthropology26 = /** @type {(inputs: _Field__Enum_Studyprograms_Study_Cultural_Anthropology26Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cultural Anthropology and European Ethnology`)
};

const de__field__enum_studyprograms_study_cultural_anthropology26 = /** @type {(inputs: _Field__Enum_Studyprograms_Study_Cultural_Anthropology26Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kulturanthropologie und Europäische Ethnologie`)
};

/**
* | output |
* | --- |
* | "Cultural Anthropology and European Ethnology" |
*
* @param {_Field__Enum_Studyprograms_Study_Cultural_Anthropology26Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const _field__enum_studyprograms_study_cultural_anthropology26 = /** @type {((inputs?: _Field__Enum_Studyprograms_Study_Cultural_Anthropology26Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<_Field__Enum_Studyprograms_Study_Cultural_Anthropology26Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en__field__enum_studyprograms_study_cultural_anthropology26(inputs)
	return de__field__enum_studyprograms_study_cultural_anthropology26(inputs)
});
export { _field__enum_studyprograms_study_cultural_anthropology26 as "_field__enum_studyPrograms_STUDY_CULTURAL_ANTHROPOLOGY" }